// extracted by mini-css-extract-plugin
export default {"narrativeOf":"NarrativeOf_narrativeOf__jpm5R","narrativeOfText":"NarrativeOf_narrativeOfText__1+n0z","value":"NarrativeOf_value__qJ-sn"};